export default __webpack_public_path__ + "static/media/Commander's Gauntlets of the Battlements.fcbeef9d.jpg";